
import { common } from './backoffice/common';
import { clinical } from './backoffice/clinical';
import { inventory } from './backoffice/inventory';
import { admin } from './backoffice/admin';
import { finance } from './backoffice/finance';
import { network } from './backoffice/network';

export const backOffice = {
  ...common,
  ...clinical,
  ...inventory,
  ...admin,
  ...finance,
  ...network
};
